import { useCallback } from "react";

import flocknoteActions from "Flocknote/actions";
import { useFlocknoteAppState } from "Flocknote/state";

/**
 * [getter, setter] for whether or a login UI is currently displaying.
 * @returns {[boolean, function]}
 */
const useIsLoginActive = () => {
  const [{ isLoginActive }, dispatch] = useFlocknoteAppState();

  const setIsLoginActive = useCallback(
    (newState) => {
      dispatch(flocknoteActions.setIsLoginActive(newState));
    },
    [dispatch]
  );

  return [isLoginActive, setIsLoginActive];
};

export default useIsLoginActive;
